module.exports = __webpack_public_path__ + "img/index_03.8a763566.jpg";